import { CheckIcon, ClipboardIcon, Globe } from "lucide-react";
import { Input } from "@/components/ui/input";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

export const ShareDialog = ({ user, slug, hasCopied, handleCopyLink }: any) => (
  <Dialog>
    <DialogTrigger asChild>
      <Button variant="ghost" size="sm">
        <div className="flex items-center gap-2">
          <Globe className="h-4 w-4 text-muted-foreground" />
          <span className="text-sm font-medium text-gray-500">Share</span>
        </div>
      </Button>
    </DialogTrigger>
    <DialogContent>
      <DialogHeader>
        <DialogTitle>Share your progress</DialogTitle>
        <DialogDescription>
          Anyone with the link can view your progress
        </DialogDescription>
      </DialogHeader>
      <div className="flex gap-2">
        <Input
          value={`${window.location.origin}/${user?.username}/${slug}`}
          readOnly
        />
        <Button onClick={handleCopyLink}>
          <span className="sr-only">Copy</span>
          {hasCopied ? <CheckIcon /> : <ClipboardIcon />}
        </Button>
      </div>
    </DialogContent>
  </Dialog>
);
